module.exports = __webpack_public_path__ + "static/media/1POLICY16.53744bb1.jpg";